
import './index.scss';
import reportWebVitals from './reportWebVitals';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

import "@fortawesome/fontawesome-free/css/all.min.css";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { msalConfig } from "./configs/MSAL.config.js";
import { createRoot } from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';

import { Provider } from 'react-redux';
import { store } from './app/store';

const msalInstance = new PublicClientApplication(msalConfig);


const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Router>
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}
      useRecaptchaNet={true}
      scriptProps={{
        async: true, // optional, default to false,
        defer: true, // optional, default to false
        appendTo: 'head', // optional, default to "head", can be "head" or "body",
        nonce: undefined // optional, default undefined
      }}
    >
      <Provider store={store}>
        <App msalInstance={msalInstance} />
      </Provider>
    </GoogleReCaptchaProvider>
  </Router>
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
